﻿import * as Model from '../../../models/models';

export class LocationIsoModalViewModel {
   
    public isAddressProcessing: boolean;
    public hasNoResults: boolean;
    public hasFailed: boolean;
    public showAddressForm: boolean;
    public isoProcessingStatusMessage: string;
    public locationCreateRequest: Model.ILocationCreateRequest;
    
    public submission: Model.ISubmission;
  
    public isEdit: boolean;
    public locationAggregate: Model.LocationAggregate;
}